import { createAction, props } from '@ngrx/store';
import { Contacto } from '../../../app/private/shared/models/Contacto';
import { Preguntas } from '../../../app/private/shared/models/preguntas';
import { IHome } from '../../../app/shared/models/Constants';
import { ContenidoClientes } from '../../../app/shared/models/ContenidoClientes';
import { ILegacyDocument } from '../../../app/shared/models/Legales';
import { IDataConfig } from '../../../app/shared/models/ParaTi.model';


/**
 * * Contacto Programa
 */
export const contactProgram = createAction(
    '[contactProgram] Agree Legals documents',
    props<{ ID_Programa: string | number }>()
);

export const successContactProgram = createAction(
    '[contactProgram] Agree Legals documents Success',
    props<{ data: Contacto[] }>()
);

export const errorContactProgram = createAction(
    '[contactProgram] Agree Legals documents Error',
    props<{ payload: Error }>()
);

export const clearContactProgram = createAction(
    '[contactProgram] Clear Contact Program'
);

/**
 * * Content Customers V1
 */
export const contentCustomersV1 = createAction(
    '[contentCustomersV1] Content Customers'
);

export const successContentCustomersV1 = createAction(
    '[ContentCustomersV1] Content Customers Success',
    props<{ data: ContenidoClientes[] }>()
);

export const errorContentCustomersV1 = createAction(
    '[ContentCustomersV1] Content Customers Error',
    props<{ payload: Error }>()
);

/**
 * * Rate Our Answer (InsertRespuestaCalificanos)
 */
export const rateOurAnswer = createAction(
    '[RateOurAnswer] Insert Rate',
    props<{ Respuestas: string }>()
);

export const successRateOurAnswer = createAction(
    '[RateOurAnswer] Insert Rate Success',
    props<{ data: any }>()
);

export const errorRateOurAnswer = createAction(
    '[RateOurAnswer] Insert Rate Error',
    props<{ payload: Error }>()
);

/**
 * * Get Mural Data (ObtenerDatosMural)
 */
export const getMuralData = createAction(
    '[MuralData] Get Mural Data'
);

export const successGetMuralData = createAction(
    '[MuralData] Get Mural Data Success',
    props<{ data: IDataConfig}>()
);

export const errorGetMuralData = createAction(
    '[MuralData] Get Mural Data Error',
    props<{ payload: Error }>()
);

/**
 * * Get Privacy Notice (ObtieneAvisoPrivacidad)
 */
export const getPrivacyNotice = createAction(
    '[PrivacyNotice] Get Privacy Notice'
);

export const successGetPrivacyNotice = createAction(
    '[PrivacyNotice] Get Privacy Notice Success',
    props<{ data: ILegacyDocument }>()
);

export const errorGetPrivacyNotice = createAction(
    '[PrivacyNotice] Get Privacy Notice Error',
    props<{ payload: Error }>()
);

export const clearGetPrivacyNotice = createAction(
    '[PrivacyNotice] Clear Get Privacy Notice'
);

/**
 * * Get Profile Config (ObtieneConfiguracionPerfil)
 */
export const getProfileConfig = createAction(
    '[ProfileConfig] Get Profile Config'
);

export const successGetProfileConfig = createAction(
    '[ProfileConfig] Get Profile Config Success',
    props<{ data: any }>()
);

export const errorGetProfileConfig = createAction(
    '[ProfileConfig] Get Profile Config Error',
    props<{ payload: Error }>()
);

/**
 * * Get Contact Info (ObtieneContactoCalificanos)
 */
export const getContactInfo = createAction(
    '[ContactInfo] Get Contact Info'
);

export const successGetContactInfo = createAction(
    '[ContactInfo] Get Contact Info Success',
    props<{ data: any[] }>()
);

export const errorGetContactInfo = createAction(
    '[ContactInfo] Get Contact Info Error',
    props<{ payload: Error }>()
);

export const clearGetContactInfo = createAction(
    '[ContactInfo] Clear Get Contact Info'
);

/**
 * * Get Inicio App (ObtieneInicioApp)
 */
export const getInicioApp = createAction(
    '[InicioApp] Get Inicio App'
);

export const successGetInicioApp = createAction(
    '[InicioApp] Get Inicio App Success',
    props<{ data: IHome }>()
);

export const errorGetInicioApp = createAction(
    '[InicioApp] Get Inicio App Error',
    props<{ payload: Error }>()
);

/**
 * * Get Mechanics Program (ObtieneMecanicaPrograma)
 */
export const getMechanicsProgram = createAction(
    '[MechanicsProgram] Get Mechanics Program'
);

export const successGetMechanicsProgram = createAction(
    '[MechanicsProgram] Get Mechanics Program Success',
    props<{ data: {imagen_url: string}[] }>()
);

export const errorGetMechanicsProgram = createAction(
    '[MechanicsProgram] Get Mechanics Program Error',
    props<{ payload: Error }>()
);

export const clearGetMechanicsProgram = createAction(
    '[MechanicsProgram] Clear Get Mechanics Program'
);

/**
 * * Get Client Program (ObtieneProgramaTendero)
 */
export const getClientProgram = createAction(
    '[ClientProgram] Get Client Program'
);

export const successGetClientProgram = createAction(
    '[ClientProgram] Get Client Program Success',
    props<{ data: any }>()
);

export const errorGetClientProgram = createAction(
    '[ClientProgram] Get Client Program Error',
    props<{ payload: Error }>()
);

/**
 * * Get Terms and Conditions (ObtieneTerminosCondiciones)
 */
export const getTermsAndConditions = createAction(
    '[TermsAndConditions] Get Terms And Conditions'
);

export const successGetTermsAndConditions = createAction(
    '[TermsAndConditions] Get Terms And Conditions Success',
    props<{ data: ILegacyDocument }>()
);

export const errorGetTermsAndConditions = createAction(
    '[TermsAndConditions] Get Terms And Conditions Error',
    props<{ payload: Error }>()
);

export const clearGetTermsAndConditions = createAction(
    '[TermsAndConditions] Clear Get Terms And Conditions'
);

/**
 * * Get Questions (ObtPreguntasCalificanos)
 */
export const getQuestions = createAction(
    '[Questions] Get Questions',
);

export const successGetQuestions = createAction(
    '[Questions] Get Questions Success',
    props<{ data: Preguntas[] }>()
);

export const errorGetQuestions = createAction(
    '[Questions] Get Questions Error',
    props<{ payload: Error }>()
);

export const clearGetQuestions = createAction(
    '[Questions] Clear Get Questions'
);
